import { saveAs } from 'file-saver'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import { Card } from '@/components/Elements'
import { FileInput, Input, Select } from '@/components/Form'
import { useAdminFunction } from '@/features/adminFunction/useAdminFunction'
import { OfferDocumentTypes } from '@/features/offers/constants'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import { Box, Button, VStack } from '@chakra-ui/react'
import { toast } from 'react-toastify'

const CostSheetPDFFunctionCard = () => {
  const methods = useForm()
  const dispatch = useDispatch()

  const { useGenerateCostSheetPdf } = useAdminFunction()
  const generateCostSheetPdf = useGenerateCostSheetPdf()

  const onSubmit = async (data) => {
    if (!data?.costSheet?._id) {
      toast.error('Missing Uploaded File')
      return
    }

    try {
      dispatch(showLoadingOverlay())
      const payload = {
        ...data,
        costSheetId: data?.costSheet?._id,
      }

      const response = await generateCostSheetPdf.mutateAsync(payload)

      const blob = new Blob([response])

      const fileName = `${data.quotationNumber.replace('/', '-')}-${data.subSystemIndex + 1}_V${data.version}_offer_costSheet.pdf`

      saveAs(blob, fileName)
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }
  return (
    <Card title="Generate Cost Sheet PDF">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Box p={5}>
            <VStack>
              <Input name="quotationNumber" label="Quotation Number" isRow />
              <Select
                name="subSystemIndex"
                label="Sub System"
                defaultValue={0}
                isRow
                options={Array.from(Array(10).keys()).map((v) => {
                  return {
                    label: v + 1,
                    value: v,
                  }
                })}
              />
              <Input name="version" label="Version" type="number" isRow />
              <Select
                name="type"
                label="Cost Sheet Type"
                isRow
                options={[
                  { label: 'Quotation', value: 'quotation' },
                  { label: 'Booking', value: 'booking' },
                ]}
              />

              <FileInput
                label="Cost Sheet (.xlsm)"
                name="costSheet"
                fileType={OfferDocumentTypes.DOCUMENTS_INTERNAL_COSTSHEET}
                canUpload
                isRequired={false}
                isRow
              />
            </VStack>
            <Button mt="6" colorScheme="blue" type="submit">
              Generate
            </Button>
          </Box>
        </form>
      </FormProvider>
    </Card>
  )
}

export default CostSheetPDFFunctionCard
